/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Plan_Seats_OneInputs */

const cs_billing_plan_seats_one = /** @type {(inputs: Billing_Plan_Seats_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 uživatel`)
};

const en_billing_plan_seats_one = /** @type {(inputs: Billing_Plan_Seats_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 seat`)
};

/**
* | output |
* | --- |
* | "1 seat" |
*
* @param {Billing_Plan_Seats_OneInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_plan_seats_one = /** @type {((inputs?: Billing_Plan_Seats_OneInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Plan_Seats_OneInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_plan_seats_one(inputs)
	return cs_billing_plan_seats_one(inputs)
});